package com.jingfangpai.api.clients

import com.jingfangpai.common.data.response.ApiResponse
import kotlinx.serialization.Serializable
import kotlinx.serialization.decodeFromString
import com.jingfangpai.common.coroutines.applicationDispatcher
import kotlinx.coroutines.launch
import io.ktor.http.*
import io.ktor.client.plugins.*
import io.ktor.client.request.*
import com.jingfangpai.common.json.json
import kotlin.js.JsName
import io.ktor.content.TextContent
import io.ktor.client.call.body
import com.jingfangpai.api.base.BaseServiceClient
import kotlin.String
import com.jingfangpai.common.orm.mapping.MedicalRecord
import com.jingfangpai.medicalRecord.model.MedicalRecordRawData
import com.jingfangpai.common.orm.mapping.MedicalRecordSignSymptom

object MedicalRecordApiClient :BaseServiceClient() {

	@JsName("getDetail")
	fun getDetail(id:kotlin.String, okCallback: (result:com.jingfangpai.common.data.response.ApiResponse<com.jingfangpai.common.orm.mapping.MedicalRecord>) -> Unit, errorCallback: (exception:Throwable) -> Unit){
		launch(applicationDispatcher) {
			val params = listOf<Pair<String,String>>(
			"id" to "${id?:""}",
			).formUrlEncode()
			try {
				val result:com.jingfangpai.common.data.response.ApiResponse<com.jingfangpai.common.orm.mapping.MedicalRecord> = httpClient.get {
				    url("/api/medicalRecord/getDetail?$params")
				}.body()
				okCallback(result)
			}catch (e:Throwable){
				errorCallback(e)
			}
		}
	}


	@JsName("getList")
	fun getList( okCallback: (result:com.jingfangpai.common.data.response.ApiResponse<kotlin.collections.List<com.jingfangpai.common.orm.mapping.MedicalRecord>>) -> Unit, errorCallback: (exception:Throwable) -> Unit){
		launch(applicationDispatcher) {
		val params = ""
			try {
				val result:com.jingfangpai.common.data.response.ApiResponse<kotlin.collections.List<com.jingfangpai.common.orm.mapping.MedicalRecord>> = httpClient.get {
				    url("/api/medicalRecord/list?$params")
				}.body()
				okCallback(result)
			}catch (e:Throwable){
				errorCallback(e)
			}
		}
	}


	@JsName("getWaitingList")
	fun getWaitingList( okCallback: (result:com.jingfangpai.common.data.response.ApiResponse<kotlin.collections.List<com.jingfangpai.common.orm.mapping.MedicalRecord>>) -> Unit, errorCallback: (exception:Throwable) -> Unit){
		launch(applicationDispatcher) {
		val params = ""
			try {
				val result:com.jingfangpai.common.data.response.ApiResponse<kotlin.collections.List<com.jingfangpai.common.orm.mapping.MedicalRecord>> = httpClient.get {
				    url("/api/medicalRecord/waitingList?$params")
				}.body()
				okCallback(result)
			}catch (e:Throwable){
				errorCallback(e)
			}
		}
	}


	@JsName("save")
	fun save(medicalRecord:com.jingfangpai.common.orm.mapping.MedicalRecord, okCallback: (result:com.jingfangpai.common.data.response.ApiResponse<com.jingfangpai.common.orm.mapping.MedicalRecord>) -> Unit, errorCallback: (exception:Throwable) -> Unit){
		launch(applicationDispatcher) {
			val params = listOf<Pair<String,String>>(
			).formUrlEncode()
			try {
				val result:com.jingfangpai.common.data.response.ApiResponse<com.jingfangpai.common.orm.mapping.MedicalRecord> = httpClient.post {
				    url("/api/medicalRecord/save?$params")
				    setBody(TextContent(json.encodeToString(com.jingfangpai.common.orm.mapping.MedicalRecord.serializer(),medicalRecord), io.ktor.http.ContentType.Application.Json))
				}.body()
				okCallback(result)
			}catch (e:Throwable){
				errorCallback(e)
			}
		}
	}


	@JsName("saveFromRawData")
	fun saveFromRawData(medicalRecordRawData:com.jingfangpai.medicalRecord.model.MedicalRecordRawData, okCallback: (result:com.jingfangpai.common.data.response.ApiResponse<com.jingfangpai.common.orm.mapping.MedicalRecord>) -> Unit, errorCallback: (exception:Throwable) -> Unit){
		launch(applicationDispatcher) {
			val params = listOf<Pair<String,String>>(
			).formUrlEncode()
			try {
				val result:com.jingfangpai.common.data.response.ApiResponse<com.jingfangpai.common.orm.mapping.MedicalRecord> = httpClient.post {
				    url("/api/medicalRecord/saveFromRawData?$params")
				    setBody(TextContent(json.encodeToString(com.jingfangpai.medicalRecord.model.MedicalRecordRawData.serializer(),medicalRecordRawData), io.ktor.http.ContentType.Application.Json))
				}.body()
				okCallback(result)
			}catch (e:Throwable){
				errorCallback(e)
			}
		}
	}


	@JsName("saveSignSymptom")
	fun saveSignSymptom(medicalRecordSignSymptom:com.jingfangpai.common.orm.mapping.MedicalRecordSignSymptom, okCallback: (result:com.jingfangpai.common.data.response.ApiResponse<com.jingfangpai.common.orm.mapping.MedicalRecordSignSymptom>) -> Unit, errorCallback: (exception:Throwable) -> Unit){
		launch(applicationDispatcher) {
			val params = listOf<Pair<String,String>>(
			).formUrlEncode()
			try {
				val result:com.jingfangpai.common.data.response.ApiResponse<com.jingfangpai.common.orm.mapping.MedicalRecordSignSymptom> = httpClient.post {
				    url("/api/medicalRecord/saveSignSymptom?$params")
				    setBody(TextContent(json.encodeToString(com.jingfangpai.common.orm.mapping.MedicalRecordSignSymptom.serializer(),medicalRecordSignSymptom), io.ktor.http.ContentType.Application.Json))
				}.body()
				okCallback(result)
			}catch (e:Throwable){
				errorCallback(e)
			}
		}
	}

}
